import { HawkSearchComponents, SearchWithinFacetComponentConfig, SearchWithinFacetComponentModel } from '@models';
import { searchService } from '@services';
import { BaseFacetComponent } from '../base-facet.component';
import defaultHtml from './search-within-facet.component.hbs';

export class SearchWithinFacetComponent extends BaseFacetComponent<SearchWithinFacetComponentConfig, SearchWithinFacetComponentModel> {
    protected override componentName: keyof HawkSearchComponents = 'search-within-facet';
    protected override defaultHtml = defaultHtml;

    protected override renderContent(): boolean {
        return !!this.data;
    }

    protected override getContentModel(): SearchWithinFacetComponentModel {
        return {
            value: this.data!.searchWithin ?? '',
            strings: {
                label: this.configuration?.strings?.label ?? 'Enter keywords'
            }
        };
    }

    protected bindChildElements(): void {
        this.rootElement.querySelectorAll('[hawksearch-input]').forEach((e) => {
            e.addEventListener('change', (event: Event) => {
                event.preventDefault();

                const element = event.currentTarget as HTMLInputElement;
                const value = element.value.trim();

                searchService.searchWithin(value);
            });
        });
    }
}
